import { useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { workflowService, ProgramStatusAuditLog } from '@/services/features/WorkflowService';

export const useWorkflowStatusAuditLog = (workflowStatusId: number | null) => {
  const [workflowStatusAuditLogs, setWorkflowStatusAuditLogs] = useState<ProgramStatusAuditLog[]>([]);
  const [auditLogsLoading, setAuditLogsLoading] = useState(false);
  const { hasuraToken } = useAuth();

  useEffect(() => {
    const fetchAuditLogs = async () => {
      if (!workflowStatusId || !hasuraToken) return;

      setAuditLogsLoading(true);
      try {
        const result = await workflowService.getWorkflowStatusAuditLog(hasuraToken, workflowStatusId);
        // Reverse to show latest records first
        setWorkflowStatusAuditLogs(result.logs.reverse());
      } catch (error) {
        console.error('Error fetching workflow status audit logs:', error);
        setWorkflowStatusAuditLogs([]);
      } finally {
        setAuditLogsLoading(false);
      }
    };

    fetchAuditLogs();
  }, [workflowStatusId, hasuraToken]);

  return {
    workflowStatusAuditLogs,
    auditLogsLoading,
  };
};
